import { render, staticRenderFns } from "./DescriptionSection.vue?vue&type=template&id=17a61d16&scoped=true&"
import script from "./DescriptionSection.vue?vue&type=script&lang=js&"
export * from "./DescriptionSection.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionSection.vue?vue&type=style&index=0&id=17a61d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a61d16",
  null
  
)

export default component.exports